module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "value": _vm.value,
      "label": _vm.label,
      "items": _vm.ranges,
      "hint": _vm.hint,
      "return-object": ""
    },
    on: {
      "change": _vm.selectionChanged
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d72344"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/DateRangeList.vue
// module id = 2462
// module chunks = 1